<template>
  <b-modal ref="removesite" class="removesitepopup" centered :lazy="true" title="Remove Website?" :hide-header-close="true" @shown="setIntialState">

    <div class="text-center p-4">
      <div>
        Are you sure you want to remove this website?
      </div>
      <h5 class="site-name">
        {{site.name}}
      </h5>
      <h6 class="deactivate-text">
        IWP Plugin will be deactivated.
      </h6>
    </div>

    <div slot="modal-footer" class="w-100">
      <div class="float-left note" style="padding: 7px;">
        <warning-icon class="icon-default warning"></warning-icon>
        This action cannot be undone.
      </div>
      <div class="float-right">
        <b-btn variant="flat" @click="close">
          No! Don't
        </b-btn>
        <b-btn variant="danger" @click="removeSite">
          Remove
          <spinner size="small" v-if="buttonLoaders.remove"></spinner>
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>

<script>
import WarningIcon from '../../assets/warning.svg';
export default {
  name: 'removesite',
  props: ['site'],
  components: {
    WarningIcon
  },
  data() {
    return {
      buttonLoaders: {
        remove: false
      }
    };
  },
  methods: {
    setIntialState() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    close() {
      this.$refs.removesite.hide();
    },
    removeSite() {
      this.buttonLoaders.remove = true;
      let payload = {};
      payload.args = {
        iwpPluginDeactivate: 1,
        siteIDs: [this.site.siteID]
      };
      payload.action = 'removeSite';
      payload.requiredData = {
        getSites: 1,
        getClientUpdateAvailableSiteIDs: 1
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        this.buttonLoaders.remove = true;
        this.$store.commit('UPDATE_SITES', response.data.getSites);
        this.$store.commit(
          'SET_CLIENT_PLUGIN_UPDATES',
          response.data.getClientUpdateAvailableSiteIDs
        );
        this.close();
      });
    }
  }
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/modals/RemoveSite.vue